// Generated from kkp-domain by 'just gen-types'. DO NOT EDIT.
export const WIRE_ACCEPT = "application/json; kkp-wire=2";
